module.exports = __webpack_public_path__ + "static/media/S (96).f8bc1a45.jpg";